import { combineReducers } from 'redux';

import multasRenainfPlaca from './multasRenainfPlaca/reducer';
import multasRenainfOrgao from './multasRenainfOrgao/reducer';

export default combineReducers({
	multasRenainfOrgao,
	multasRenainfPlaca,
});
